import {createLocalStorage} from '@republic/foundation/storage/local';

export default createLocalStorage('local');
